import {UserBankingDataModel} from './user-banking-data-model';
import {TerminalDeliveryModel} from './terminal-delivery-model';

export class UserDataModel {
    tipoVia = '';
    nombreVia = '';
    numero = '';
    planta = '';
    puerta = '';
    escalera = '';
    codigoPostal = '';
    localidad  = '';
    provincia = '';
    doctype = '';
    doc = '';
    country = '';
    firstName = '';
    surname1 = '';
    surname2 = '';
    birthday = '';
    sex = '';
    company = '';
    phone = '';
    email = '';
    bankingData = new UserBankingDataModel();
    terminalDelivery = new TerminalDeliveryModel();
}
